var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.type,"bottom":"","right":""},nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }